<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">Edit Enquiry</h1>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'spancoList' }" class="button is-small is-link">Back to list</router-link>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <div class="columns">
        <div class="column is-3">
          <div class="field">
            <label class="label">Enquiry Code :{{ enquiryCode }}</label>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">Center Added :{{ EnquiryObject.centerAdded }}</label>
          </div>
        </div>
      </div>

      <form @submit.prevent="saveEnquiry">
        <div>
          <card-component>
            <div class="columns">
              <div class="column ">
                <div class="field">
                  <label class="label">Select Academic Year <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="academicYear" disabled v-model="EnquiryObject.academicYearID" required>
                        <option disabled value>--Select--</option>
                        <option :value="year.id" v-for="year in academicYears" :key="year.id"> {{ year.academicYear }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column ">
                <div class="field">
                  <label class="label">Select Franchisee <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select required disabled v-model="EnquiryObject.franchiseeID">
                        <option disabled value>---Select---</option>
                        <option :value="franchisee.id" v-for="franchisee in franchiseeArr" :key="franchisee.id">{{ franchisee.companyName }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column ">
                <div class="field">
                  <label class="label">Select Class <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="academicYear" v-model="EnquiryObject.classID" disabled required>
                        <option disabled value>--Select--</option>
                        <option :value="class1.id" v-for="class1 in classes" :key="class1.id"> {{ class1.name }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Student First Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" type="text" disabled required title="Enter Valid  details !" v-model.trim="EnquiryObject.studentFirstName" maxlength="50" />
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">
                    Parent Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input class="input" type="text" disabled required title="Enter Valid  details !" v-model.trim="EnquiryObject.fatherName" maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Parent Mobile number
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      required
                      disabled
                      onKeyPress="if(this.value.length==10) return false;"
                      v-model.trim="EnquiryObject.fatherMobile"
                      maxlength="10"
                      type="number"
                      title="Enter Valid 10 digit Mobile Number"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Parent Email ID
                  </label>

                  <div class="control">
                    <input autocomplete="new-email" class="input" type="email" name="email" v-model="EnquiryObject.fatherEmailID" disabled maxlength="100" title="Enter Valid Email id" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Pincode</label>
                  <div class="control">
                    <input class="input" type="number" title="Enter Valid  details !" v-model.trim="EnquiryObject.pincode" disabled maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">City</label>
                  <div class="control">
                    <input class="input" type="text" title="Enter Valid  details !" v-model.trim="EnquiryObject.city" disabled maxlength="50" />
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">State</label>
                  <div class="control">
                    <input class="input" type="text" title="Enter Valid  details !" v-model.trim="EnquiryObject.state" disabled maxlength="50" />
                  </div>
                </div>
              </div>
              <div class="column ">
                <div class="field">
                  <label class="label">Address 1 </label>

                  <div class="control">
                    <textarea v-model.trim="EnquiryObject.address1" disabled type="text" class="textarea is-small" maxlength="300"></textarea>
                  </div>
                </div>
              </div>
              <div class="column ">
                <div class="field">
                  <label class="label">Message </label>

                  <div class="control">
                    <textarea v-model.trim="EnquiryObject.message" disabled type="text" class="textarea is-small" maxlength="300"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column ">
                <div class="field">
                  <label class="label">Spanco<span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="spanco" v-model="EnquiryObject.spanco" required>
                        <option disabled value>--Select--</option>
                        <option :value="key" v-for="(val, key) in spanco" :key="key"> {{ key }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column ">
                <div class="field">
                  <label class="label">Spanco Status<span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select required v-model="EnquiryObject.spancoStatus" @change="setSpancoSubstatus()">
                        <option disabled value>---Select---</option>
                        <option :value="key" v-for="(val, key) in spanco[EnquiryObject.spanco]" :key="key">{{ key }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Spanco Substatus<span class="has-text-danger">*</span></label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select name="spancoSubStatus" v-model="EnquiryObject.spancoSubStatus" required v-if="EnquiryObject.spancoStatus">
                        <option disabled value>--Select--</option>
                        <option :value="val" v-for="val in spanco[EnquiryObject.spanco][EnquiryObject.spancoStatus]" :key="val"> {{ val }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-two-thirds">
                <div class="field">
                  <label class="label">Remarks </label>

                  <div class="control">
                    <textarea v-model.trim="EnquiryObject.remark" type="text" class="textarea is-normal" placeholder="pls put your remarks here.." maxlength="300"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
            <div class="columns" v-if="summary.length">
              <div class="column">
                <div class="field">
                  <label class="label">Summary:</label>
                </div>
                <b-table :data="summary" :columns="summaryColumns"></b-table>
              </div>
            </div>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import _ from 'lodash'

export default {
  name: 'EditSpanco',
  components: {
    CardComponent
  },
  props: ['enquiryCode', 'radio'],
  data () {
    return {
      summary: [],
      summaryColumns: [
        {
          field: 'spanco',
          label: 'Spanco'
        },
        {
          field: 'spancoStatus',
          label: 'Spanco Status'
        },
        {
          field: 'spancoSubStatus',
          label: 'Spanco SubStatus',
          centered: true
        },
        {
          field: 'remark',
          label: 'Remark',
          centered: true
        },
        {
          field: 'createdBy',
          label: 'Created By'
        },
        {
          field: 'createdAt',
          label: 'Created At'
        }
      ],
      classes: [],
      loadingComponent: null,
      academicYears: [],
      franchiseeArr: [],
      isShowHistory: true,
      EnquiryObject: {
        id: '',
        studentFirstName: '',
        pointOfContact: '',
        fatherName: '',
        fatherEmailID: '',
        address1: '',
        city: '',
        state: '',
        pincode: '',
        fatherMobile: '',
        academicYear: '',
        classID: '',
        message: '',
        franchiseeID: '',
        academicYearID: '',
        centerAdded: '',
        spanco: '',
        spancoStatus: '',
        spancoSubStatus: '',
        remarks: ''
      },
      spanco: {
        Suspect: {
          Yes: ['NA'],
          'Yet To Call': ['NA'],
          'Called But No Response': ['NA'],
          'Junk/Not Interested': [
            'Attempted thrice and no response',
            'Invalid Number',
            'Disconnected the call after introduction',
            'Age Eligibilty',
            'Admitted in Other School',
            'Filled by Mistake',
            'Not Interested',
            'Location/Distance Issue',
            'Others'
          ]
        },
        Prospect: {
          Cold: ['Interested-Call Back', 'Interested - Busy'],
          Warm: ['NA'],
          Hot: ['NA'],
          Dead: [
            'Admitted in other school',
            'Attempted thrice and no response',
            'Disconnected the call after introduction',
            'Not interested',
            'Online classes',
            'Enquired for Day care / after school activities',
            'Location / Transport issue',
            'Any other (Clear remarks to be mentioned in “Remarks” Column.'
          ]
        },
        Approach: {
          'Online Counselling Done': ['NA'],
          'Offline Counselling Done': ['NA'],
          'Appointments Fixed': ['NA'],
          'Appointment Pending': ['NA']
        },
        Negotiate: {
          'Application Fee Link Sent': ['NA'],
          'Need More Info': ['NA'],
          'Visit the Campus': ['NA'],
          'Need Demo': ['NA'],
          'Drop Off': ['Facilities', 'Fees/Concession', 'Online Classes', 'Application Fee Link Sent- No Response', 'Transport Facilities', 'Curriculum', 'Others'],
          'Decision Pending': ['NA']
        },
        Close: {
          'Admission Form Completed': ['NA'],
          'Tution Fee Paid': ['NA']
        },
        'On Board': {
          'Admission Confirmed': ['NA']
        }
      }
    }
  },
  async created () {
    try {
      // while editing Enquiry get detail
      if (this.enquiryCode) {
        await this.getAcademicYears()
        await this.getFranchiseeList()
        await this.getClassList()
        this.loadingComponent = this.$buefy.loading.open()

        let { data } = await http.get(`${constants.API_URL}/api/spanco/${this.enquiryCode}`)

        if (data) {
          this.EnquiryObject = {
            id: data[0].id,
            studentFirstName: data[0].studentFirstName,
            pointOfContact: 'FATHER',
            fatherName: data[0].fatherName,
            fatherEmailID: data[0].fatherEmailID,
            address1: data[0].address1,
            city: data[0].city,
            state: data[0].state,
            pincode: data[0].pincode,
            fatherMobile: data[0].fatherMobile,
            classID: data[0].classID,
            academicYearID: data[0].academicYearID,
            franchiseeID: data[0].franchiseeID,
            message: data[0].message,
            centerAdded: data[0].franchiseeName,
            spanco: _.get(data[0], 'spanco.spanco'),
            spancoStatus: _.get(data[0], 'spanco.spancoStatus'),
            spancoSubStatus: _.get(data[0], 'spanco.spancoSubStatus'),
            remark: _.get(data[0], 'spanco.remark')
          }
          if (_.get(data[0], 'spanco.spancoLogs')) {
            this.summary = _.get(data[0], 'spanco.spancoLogs')
            // console.log(this.summary)
          }
        }
        this.loadingComponent.close()
      }
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      return this.$buefy.dialog.alert({
        type: 'is-danger',
        message: errorMessage,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',

        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  },
  methods: {
    showHistory: function () {
      this.isShowHistory = true
    },
    setSpancoSubstatus: function () {
      if (this.spanco[this.EnquiryObject.spanco][this.EnquiryObject.spancoStatus][0] === 'NA') {
        this.EnquiryObject.spancoSubStatus = 'NA'
      }
    },
    saveEnquiry: async function () {
      try {
        let payLoad = {
          enquiryID: this.EnquiryObject.id,
          spanco: this.EnquiryObject.spanco,
          spancoStatus: this.EnquiryObject.spancoStatus,
          spancoSubStatus: this.EnquiryObject.spancoSubStatus
        }
        await http.post(`${constants.API_URL}/api/spanco`, payLoad)
        if (this.EnquiryObject.remark) {
          payLoad.remark = this.EnquiryObject.remark
        }
        let radio2 = this.radio

        this.$router.push({ name: 'spancoList', params: { radio2 } })
        this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClassList: async function () {
      try {
        const classes = await http.get(`${constants.API_URL}/api/students/class`)
        this.classes = classes.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    getFranchiseeList: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
